'use client';

import { ELanguage } from '../../Utils/constants.js';

var translator = function (txt, resource, language) {
    if (!(resource === null || resource === void 0 ? void 0 : resource[txt]))
        return txt;
    switch (language) {
        case ELanguage.EN:
            return txt;
        case ELanguage.VI:
            return resource[txt];
        default:
            return txt;
    }
};

export { translator };
//# sourceMappingURL=helper.js.map
